import React from "react";
import { Route, Switch, Redirect } from "wouter";
import { PlansPage } from "./pages/PlansPage.js";
import { CheckoutPage } from "./pages/CheckoutPage.js";
import { SuccessPage } from "./pages/SuccessPage.js";
import { PixPendingPage } from "./pages/PixPendingPage.js";
import { IntegratedPage } from "./pages/IntegratedPage.js";
import { StripeCheckoutPage } from "./pages/StripeCheckoutPage.js";
import { AdminApp } from "./pages/admin/AdminApp.js";

export function App() {
  return (
    <Switch>
      <Route path="/" component={PlansPage} />
      <Route path="/plans" component={PlansPage} />
      <Route path="/checkout" component={CheckoutPage} />
      <Route path="/success" component={SuccessPage} />
      <Route path="/pix/pending/:id" component={PixPendingPage} />
      <Route path="/stripe/checkout/:id" component={StripeCheckoutPage} />
      <Route path="/integrated" component={IntegratedPage} />
      <Route path="/admin" nest>
        <AdminApp />
      </Route>
      <Route>
        <Redirect to="/" />
      </Route>
    </Switch>
  );
}
